import React, { useState } from 'react';

import ReuniaoSteper from "../../../components/reunioes/reunioesRegister/reuniaoSteper";
import FormHeader from "../../../components/shared/form/formHeader";

import AbaSobre from "../../../components/reunioes/reunioesRegister/reuniaoAbas/reuniaoAbaSobre";
import AbaPauta from "../../../components/reunioes/reunioesRegister/reuniaoAbas/reuniaoAbaPauta";
import AbaDoc from "../../../components/reunioes/reunioesRegister/reuniaoAbas/reuniaoAbaDocumentos";
import AbaUsers from "../../../components/reunioes/reunioesRegister/reuniaoAbas/reuniaoAbaConvidados";

const opcoes = [
  "Sobre",
  "Pauta e Ata",
  "Documentos",
  "Convidados",
];

const CadastrarReuniao = (props) => {

  const {history} = props;

  const initialState = {
    id: '',
    edicao: 1,
    periodicidade: '',
    conselho: '',
    data: '',
    hora: '',
    cep: '',
    estado: { "id": null, "nome": "" },
    cidade: '',
    endereco: '',
    descricao: '',
    expediente: '',
    ordem: '',
    comunicacoes: '',
    outros: '',
    arquivos: [],
    usuariosConvidados: [],
    cidadesDisponiveis: null,
  }

  const [dadosReuniao, setDadosReuniao] = useState(initialState);

  const [aba, setAba] = useState(0);
  const [validados, setValidados] = useState({
    "Sobre": {
      validado: false,
    },
    "Pauta e Ata": {
      validado: false,
    },
    "Documentos": {
      validado: false,
    },
    "Convidados": {
      validado: false,
    }
  })

  const handleChange = (aba, num) => {
    if (validados[aba].validado) {
      setAba(num);
    }
  }

  const abaAtiva = (num) => {
    switch (num) {
      case 0:
        return <AbaSobre dados={dadosReuniao} updateDados={setDadosReuniao} handleStepper={setAba} validar={validados["Sobre"]} />;
      case 1:
        return <AbaPauta dados={dadosReuniao} updateDados={setDadosReuniao} handleStepper={setAba} validar={validados["Pauta e Ata"]} />;
      case 2:
        return <AbaDoc dados={dadosReuniao} updateDados={setDadosReuniao} handleStepper={setAba} validar={validados["Documentos"]} />;
      case 3:
        return <AbaUsers dados={dadosReuniao} updateDados={setDadosReuniao} history={history} handleStepper={setAba} validar={validados["Convidados"]} />;
    }
  }

  return (
    <>
      <FormHeader titulo="Nova Reunião " />
      <div style={{ position: 'relative', top: 120, padding: '0 24px' }}>
        <ReuniaoSteper indexAtivo={aba} opcoes={opcoes} clickHandle={handleChange} />
      </div>
      {abaAtiva(aba)}
    </>
  );
}

export default CadastrarReuniao;
